import React, { useState, useCallback, useEffect } from 'react';
import axios from 'axios';
import { API_URLS } from '../../apiConfig';
//const API_PRODUCTOS_URL = 'http://localhost:3001/api/productos';
//const API_PRODUCTOS_URL = 'https://scagliacons.cloud/api/productos';
//const API_MOVIMIENTOS_URL = 'https://scagliacons.cloud/api/movimientos';
//const API_DESTINOS_URL = 'https://scagliacons.cloud/api/destinos';

function ProductManagement() {
    const [productos, setProductos] = useState([]);
    const [destinos, setDestinos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    const [formData, setFormData] = useState({ 
        id: null, codigo: '', descripcion: '', 
        marca: '', modelo: '', serie: '', 
        ubicacion: '', stock: 0 
    });

    const [isMovementModalOpen, setIsMovementModalOpen] = useState(false);
    const [movementData, setMovementData] = useState({
        productId: null, productCode: '', type: 'entrada', quantity: 1, reason: ''
    });

    // Cargar destinos al inicio
    useEffect(() => {
        const fetchDestinos = async () => {
            try {
                const token = localStorage.getItem('token');
                const res = await axios.get(API_URLS.DESTINOS, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setDestinos(res.data);
            } catch (err) { console.error("Error al cargar destinos", err); }
        };
        fetchDestinos();
    }, []);

    const fetchProductos = useCallback(async (term = searchTerm) => {
        if (!term.trim()) return;
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const res = await axios.get(`${API_URLS.PRODUCTOS}?search=${term}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setProductos(res.data);
            setIsError(false);
            if(res.data.length === 0) setMessage(`No se hallaron productos para "${term}"`);
        } catch (err) {
            setMessage('Error al buscar productos.');
            setIsError(true);
        } finally { setLoading(false); }
    }, [searchTerm]);

    const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

    // NUEVO: Función para eliminar producto
   const handleDelete = async (id, codigo) => {
    // Confirmación de seguridad
    if (!window.confirm(`¿Estás seguro de eliminar el equipo ${codigo}?`)) return;

    const token = localStorage.getItem('token');
    try {
        // Enviamos la petición DELETE a la URL con el ID al final
        await axios.delete(`${API_URLS.PRODUCTOS}/${id}`, {
            headers: { Authorization: `Bearer ${token}` }
        });

        setMessage(`✅ Producto ${codigo} eliminado satisfactoriamente.`);
        setIsError(false);
        
        // IMPORTANTE: Refrescar la lista para que el producto desaparezca de la tabla
        fetchProductos(); 
        
    } catch (err) {
        const errorMsg = err.response?.data?.message || "Error al intentar eliminar.";
        setMessage(`❌ ${errorMsg}`);
        setIsError(true);
    }
};
    const handleSubmit = async (e) => {
    e.preventDefault();

    // 1. VALIDACIÓN: Stock mínimo inicial para productos nuevos
    if (!formData.id && (parseInt(formData.stock) <= 0 || !formData.stock)) {
        setMessage("❌ El stock inicial debe ser al menos 1 para registrar un nuevo equipo.");
        setIsError(true);
        return; // Detiene la ejecución
    }

    // 2. VALIDACIÓN: Código duplicado (que ya teníamos)
    if (!formData.id) {
        const existe = productos.some(p => p.codigo.toLowerCase() === formData.codigo.toLowerCase());
        if (existe) {
            setMessage(`❌ El código "${formData.codigo}" ya existe en el sistema.`);
            setIsError(true);
            return;
        }
    }

    const token = localStorage.getItem('token');
    try {
        if (formData.id) {
            // ... lógica de actualización (PUT)
            await axios.put(`${API_URLS.PRODUCTOS}/${formData.id}`, formData, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setMessage("✅ Producto actualizado correctamente.");
        } else {
            // ... lógica de creación (POST)
            await axios.post(API_URLS.PRODUCTOS, formData, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setMessage("✅ Producto creado con éxito.");
        }
        setIsError(false);
        handleCancelEdit();
        if (searchTerm) fetchProductos();
    } catch (err) {
        setMessage(err.response?.data?.message || "❌ Error en la solicitud.");
        setIsError(true);
    }
};
    const handleCancelEdit = () => {
        setFormData({ id: null, codigo: '', descripcion: '', marca: '', modelo: '', serie: '', ubicacion: '', stock: 0 });
    };

    const handleEdit = (p) => {
        setFormData(p);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const openMovementModal = (p) => {
        setMovementData({ productId: p.id, productCode: p.codigo, type: 'entrada', quantity: 1, reason: '' });
        setIsMovementModalOpen(true);
    };

    const handleMovementSubmit = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem('token');
            const res = await axios.post(`${API_URLS.MOVIMIENTOS}/registrar`, {
                productoId: movementData.productId,
                cantidad: movementData.quantity,
                tipo: movementData.type,
                razon: movementData.reason
            }, { headers: { Authorization: `Bearer ${token}` } });

            if (res.data.aviso) {
                setMessage(`⚠️ Alerta: ${res.data.aviso}`);
                setIsError(true); 
            } else {
                setMessage("📦 Movimiento registrado con éxito.");
                setIsError(false);
            }
            setIsMovementModalOpen(false);
            fetchProductos();
        } catch (err) {
            setMessage("❌ Error al registrar movimiento.");
            setIsError(true);
        }
    };

    return (
        <div className="form-container-responsive animate-fadeIn">
            {/* ENCABEZADO */}
            <div className="mb-8">
                <span className="text-[10px] font-black text-gray-400 uppercase tracking-[0.3em] block mb-1">Inventario Maestro</span>
                <h2 className="text-3xl font-bold text-gray-800 flex items-center gap-3">
                    <i className="bi bi-box-seam-fill text-[#FFD700]"></i>
                    Control de Herramientas
                </h2>
            </div>

            {message && (
                <div className={`${isError ? 'bg-red-50 text-red-600' : 'bg-gray-900 text-[#FFD700]'} p-4 rounded-2xl mb-8 flex items-center shadow-sm text-sm font-bold animate-fadeIn`}>
                    <i className={`bi ${isError ? 'bi-exclamation-triangle-fill' : 'bi-check-circle-fill'} me-3`}></i>
                    {message}
                    <button className="ml-auto" onClick={() => setMessage('')}>✕</button>
                </div>
            )}

            {/* FORMULARIO DE REGISTRO / EDICIÓN */}
            <div className="bg-white p-8 rounded-[2.5rem] shadow-sm border border-gray-100 mb-10">
                <div className="form-section-header !mt-0 flex items-center gap-2">
                    {formData.id ? '🛠️ Editando: ' + formData.codigo : '➕ Alta de Nuevo Producto'}
                </div>
                <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-12 gap-5">
                    <div className="md:col-span-2">
                        <label className="label-modern">Código</label>
                        <input type="text" name="codigo" className="input-modern uppercase" value={formData.codigo} onChange={handleChange} required disabled={!!formData.id} placeholder="P-001" />
                    </div>
                    <div className="md:col-span-4">
                        <label className="label-modern">Descripción</label>
                        <input type="text" name="descripcion" className="input-modern" value={formData.descripcion} onChange={handleChange} required placeholder="Nombre del equipo" />
                    </div>
                    <div className="md:col-span-3">
                        <label className="label-modern">Ubicación Actual</label>
                        <select name="ubicacion" className="input-modern" value={formData.ubicacion} onChange={handleChange} required>
                            <option value="">Seleccionar...</option>
                            {destinos.map(d => <option key={d.id} value={d.nombre}>{d.nombre}</option>)}
                        </select>
                    </div>
                    <div className="md:col-span-3">
                        <label className="label-modern">Marca</label>
                        <input type="text" name="marca" className="input-modern" value={formData.marca} onChange={handleChange} placeholder="Bosch, DeWalt..." />
                    </div>
                    <div className="md:col-span-3">
                        <label className="label-modern">Modelo</label>
                        <input type="text" name="modelo" className="input-modern" value={formData.modelo} onChange={handleChange} />
                    </div>
                    <div className="md:col-span-3">
                        <label className="label-modern">N° Serie</label>
                        <input type="text" name="serie" className="input-modern" value={formData.serie} onChange={handleChange} />
                    </div>
                    {!formData.id && (
                        <div className="md:col-span-2">
                            <label className="label-modern">Stock Inicial</label>
                            <input type="number" 
                            name="stock" 
                            className="input-modern font-bold text-center" 
                            value={formData.stock} onChange={handleChange} 
                            min="1" //<---uno como minimina para stock inicial 
                            required/>
                        </div>
                    )}
                    <div className="md:col-span-4 flex items-end gap-2">
                        {formData.id && (
                            <button type="button" className="btn-light-modern flex-1 py-3 rounded-2xl border font-bold" onClick={handleCancelEdit}>Cancelar</button>
                        )}
                        <button type="submit" className={`btn-corporate flex-grow py-3 ${formData.id ? 'bg-amber-500 hover:bg-amber-600' : ''}`}>
                            {formData.id ? 'Actualizar Datos' : 'Registrar Producto'}
                        </button>
                    </div>
                </form>
            </div>

            {/* BUSCADOR Y LISTADO */}
            <div className="bg-white rounded-[2.5rem] shadow-sm border border-gray-100 overflow-hidden">
                <div className="p-6 bg-gray-50/50 border-b">
                    <form onSubmit={(e) => { e.preventDefault(); fetchProductos(); }} className="flex gap-3">
                        <div className="relative flex-grow">
                            <span className="absolute inset-y-0 left-0 pl-4 flex items-center text-gray-400">
                                <i className="bi bi-search"></i>
                            </span>
                            <input type="text" className="input-modern pl-11" placeholder="Buscar por código, nombre o marca..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                        </div>
                        <button type="submit" className="btn-corporate px-8" disabled={loading}>{loading ? '...' : 'Buscar'}</button>
                    </form>
                </div>

                <div className="overflow-x-auto">
                    <table className="w-full text-left border-collapse">
                        <thead>
                            <tr className="text-[11px] font-black text-gray-400 uppercase tracking-widest bg-gray-50/50">
                                <th className="px-6 py-4">Ref. Código</th>
                                <th className="px-6 py-4">Descripción / Especificaciones</th>
                                <th className="px-6 py-4 text-center">Disponibilidad</th>
                                <th className="px-6 py-4">Ubicación</th>
                                <th className="px-6 py-4 text-right">Acciones</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-100">
                            {productos.length > 0 ? (
                                productos.map(p => (
                                    <tr key={p.id} className="hover:bg-blue-50/30 transition-colors group">
                                        <td className="px-6 py-4">
                                            <span className="bg-gray-100 text-gray-700 px-3 py-1 rounded-lg text-xs font-bold">{p.codigo}</span>
                                        </td>
                                        <td className="px-6 py-4">
                                            <div className="font-bold text-gray-800">{p.descripcion}</div>
                                            <div className="text-[10px] text-gray-400 font-bold uppercase tracking-tighter">
                                                {p.marca} {p.modelo} <span className="mx-1">•</span> SN: {p.serie || 'N/A'}
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 text-center">
                                            <span className={`px-3 py-1 rounded-full text-xs font-black ${p.stock <= 5 ? 'bg-red-100 text-red-600' : 'bg-green-100 text-green-700'}`}>
                                                {p.stock} UNI
                                            </span>
                                        </td>
                                        <td className="px-6 py-4 text-xs font-medium text-gray-500">
                                            <i className="bi bi-geo-alt me-1 text-amber-500"></i>{p.ubicacion}
                                        </td>
                            <td className="px-6 py-4">
                                <div className="flex justify-end gap-3">
                                    {/* BOTÓN EDITAR - NARANJA VIBRANTE */}
                                    <button 
                                        onClick={() => handleEdit(p)} 
                                        className="flex items-center gap-2 px-4 py-2 bg-[#f59e0b] text-white text-xs font-black rounded-xl hover:bg-[#d97706] transition-all shadow-md border-b-4 border-[#b45309]"
                                    >
                                        <i className="bi bi-pencil-square"></i>
                                        <span>EDITAR</span>
                                    </button>

                                    {/* BOTÓN ELIMINAR - ROJO INTENSO */}
                                    <button 
                                        onClick={() => handleDelete(p.id, p.codigo)} 
                                        className="flex items-center gap-2 px-4 py-2 bg-[#ef4444] text-white text-xs font-black rounded-xl hover:bg-[#dc2626] transition-all shadow-md border-b-4 border-[#b91c1c]"
                                    >
                                        <i className="bi bi-trash3-fill"></i>
                                        <span>ELIMINAR</span>
                                    </button>
                                </div>
                            </td>
                            </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" className="px-6 py-20 text-center text-gray-400 font-medium">
                                        {searchTerm ? 'No se hallaron resultados para la búsqueda.' : 'Inicie una búsqueda para gestionar productos.'}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* MODAL DE MOVIMIENTOS */}
            {isMovementModalOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-gray-900/40 backdrop-blur-sm animate-fadeIn">
                    <div className="bg-white w-full max-w-md rounded-[2.5rem] shadow-2xl overflow-hidden border border-gray-100 animate-slideUp">
                        <form onSubmit={handleMovementSubmit}>
                            <div className="p-6 bg-gray-900 text-white flex justify-between items-center">
                                <div>
                                    <p className="text-[10px] font-black uppercase tracking-widest text-[#FFD700]">Ajuste de Existencias</p>
                                    <h5 className="text-lg font-bold">Ref: {movementData.productCode}</h5>
                                </div>
                                <button type="button" onClick={() => setIsMovementModalOpen(false)} className="w-10 h-10 rounded-full hover:bg-white/10 flex items-center justify-center transition-colors">✕</button>
                            </div>
                            
                            <div className="p-8">
                                <div className="bg-gray-100 p-1 rounded-2xl flex gap-1 mb-6">
                                    <button type="button" onClick={() => setMovementData({...movementData, type: 'entrada'})} className={`flex-1 py-3 rounded-xl text-xs font-black uppercase transition-all ${movementData.type === 'entrada' ? 'bg-white text-green-600 shadow-sm' : 'text-gray-400'}`}>Entrada</button>
                                    <button type="button" onClick={() => setMovementData({...movementData, type: 'salida'})} className={`flex-1 py-3 rounded-xl text-xs font-black uppercase transition-all ${movementData.type === 'salida' ? 'bg-white text-red-600 shadow-sm' : 'text-gray-400'}`}>Salida</button>
                                </div>

                                <div className="space-y-4">
                                    <div>
                                        <label className="label-modern">Cantidad a Movilizar</label>
                                        <input type="number" className="input-modern text-center text-2xl font-black" min="1" value={movementData.quantity} onChange={(e) => setMovementData({...movementData, quantity: e.target.value})} required />
                                    </div>
                                    <div>
                                        <label className="label-modern">Motivo o Destino</label>
                                        <textarea className="input-modern min-h-[100px]" value={movementData.reason} onChange={(e) => setMovementData({...movementData, reason: e.target.value})} placeholder="Ej: Obra Norte, Reposición..." required></textarea>
                                    </div>
                                </div>
                            </div>

                            <div className="p-6 bg-gray-50 flex gap-3">
                                <button type="submit" className={`btn-corporate flex-grow py-4 rounded-2xl font-black tracking-tight ${movementData.type === 'entrada' ? '!bg-green-600' : '!bg-red-600'}`}>
                                    CONFIRMAR {movementData.type.toUpperCase()}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}

export default ProductManagement;
